import { cx } from '@twind/core';

export default function LiveChatSendIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      className={cx('ostro-send-message-icon', className)}
    >
      <rect
        width="36"
        height="36"
        rx="18"
        fill="#1E1E1E"
      />
      <path
        d="M24.3574 11.0723L16.1074 19.3223"
        stroke="white"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3574 11.0723L19.1074 26.0723L16.1074 19.3223L9.35742 16.3223L24.3574 11.0723Z"
        stroke="white"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
